import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaStar,
  FaArrowRight,
  FaPhone,
  FaWater,
  FaWhatsapp,
  FaBolt,
  FaCrosshairs
} from 'react-icons/fa';
import './Home.css';
import javiFisio from '../images/javi_fisio2.jpg';
import javiFisio2 from '../images/javi_fisio.jpg';


const Home = () => {
  const features = [
    {
      icon: <FaBolt />,
      title: "(ENA)",
      description: "La Electroneuroacupuntura Técnica avanzada que combina acupuntura con estimulación eléctrica para modular el sistema nervioso y reducir el dolor."
    },
    {
      icon: <FaCrosshairs />,
      title: "Punción Seca",
      description: "Técnica invasiva que elimina puntos gatillo y contracturas musculares para aliviar el dolor y mejorar la movilidad."
    },
    {
      icon: <FaWater />,
      title: "Presoterapia",
      description: "Tratamiento que estimula la circulación linfática y venosa para reducir inflamación, recuperarte más rápido y prevenir lesiones"
    }
  ];

  const testimonials = [
    {
      name: "María García",
      text: "La ENA me ayudó a recuperarme completamente de mi tendinopatía aquílea. Excelente técnica y profesional.",
      rating: 5
    },
    {
      name: "Carlos López",
      text: "La punción seca eliminó mis contracturas en la espalda. Alivio inmediato y mejora notable de la movilidad.",
      rating: 5
    },
    {
      name: "Ana Martínez",
      text: "Después de meses de dolor por epicondilitis, la ENA fue la solución. Muy agradecida por los resultados.",
      rating: 5
    }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero with-bg">
        <div className="container">
          <div className="hero-content">
            <motion.div 
              className="hero-text"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1>
                Especialista en Electroneuroacupuntura y Punción Seca
              </h1>
              <p>
                Tratamientos avanzados de fisioterapia con técnicas especializadas para aliviar el dolor y acelerar tu recuperación. 
                Especializado en ENA y Punción Seca para lesiones deportivas y patologías neuromusculares.
              </p>
              <div className="hero-buttons">
                <Link to="/contacto" className="btn btn-primary">
                  Pedir Cita
                </Link>
                <Link to="/servicios" className="btn btn-secondary">
                  Ver Servicios
                </Link>
              </div>
              <div className="hero-contact">
                <a href="tel:+34654384937" className="contact-item">
                  <FaPhone />
                  <span>654 38 49 37</span>
                </a>
                <a href="https://wa.me/34654384937" className="contact-item">
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </a>
              </div>
            </motion.div>
            <motion.div 
              className="hero-image"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <img src={javiFisio} alt="Fisioterapeuta Javi" className="hero-img" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Especialidades Principales</h2>
            <p>Técnicas avanzadas para el tratamiento del dolor y la recuperación neuromuscular</p>
          </motion.div>
          
          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div 
                key={index}
                className="feature-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="feature-icon">
                  {feature.icon}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview section">
        <div className="container">
          <div className="about-content">
            <motion.div 
              className="about-text"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2>Sobre Mí</h2>
              <p>
                Soy fisioterapeuta colegiado especializado en técnicas avanzadas como la 
                Electroneuroacupuntura (ENA) y la Punción Seca. Con años de experiencia 
                en el tratamiento de lesiones deportivas y patologías neuromusculares.
              </p>
              <p>
                Mi enfoque se basa en técnicas científicamente probadas que combinan 
                la medicina tradicional con la tecnología moderna para lograr resultados 
                efectivos y duraderos en la recuperación de mis pacientes.
              </p>
              <Link to="/sobre-mi" className="btn btn-secondary">
                Conoce más sobre mí
                <FaArrowRight />
              </Link>
            </motion.div>
            <motion.div 
              className="about-image"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={javiFisio2} alt="Javier en acción" className="about-img" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Lo que dicen los pacientes</h2>
            <p>Experiencias reales de pacientes satisfechos</p>
          </motion.div>
          
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <motion.div 
                key={index}
                className="testimonial-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <strong>{testimonial.name}</strong>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>¿Listo para empezar tu recuperación?</h2>
            <p>
              No esperes más. Tu salud y bienestar son nuestra prioridad. 
              Reserva tu cita hoy mismo y da el primer paso hacia tu recuperación.
            </p>
            <div className="cta-buttons">
              <Link to="/contacto" className="btn btn-primary">
                Reservar Cita
              </Link>
              <a href="https://wa.me/34654384937" className="btn btn-secondary">
                <FaWhatsapp />
                Consultar por WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home; 